module.exports = __webpack_public_path__ + "static/media/img3.af7cf248.jpg";